(function () {
  if (window.__palsCards) return;
  window.__palsCards = true;
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var n = cents / 100;
      var s = k.indexOf('no_decimals') > -1 ? String(Math.round(n)) : n.toFixed(2);
      var comma = k.indexOf('comma') > -1;
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      return p.join(comma ? ',' : '.');
    });
  }  function moneyR(c, fmt) { return money(Math.round(c / 100) * 100, fmt).replace(/([.,])00(?!\d)/, ''); }

  function variants(card) {
    if (card.__pcv !== undefined) return card.__pcv;
    var el = card.querySelector('[data-pc-variants]');
    try { card.__pcv = el ? JSON.parse(el.textContent) : null; } catch (e) { card.__pcv = null; }
    return card.__pcv;
  }
  function sel(card) {
    if (!card.__pcs) { try { card.__pcs = JSON.parse(card.getAttribute('data-sel') || '[]'); } catch (e) { card.__pcs = []; } }
    return card.__pcs;
  }
  function swapImages(card, dot) {
    var img = card.querySelector('.pc__main');
    if (img && dot.dataset.src && img.tagName === 'IMG') {
      img.src = dot.dataset.src;
      if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
    }
    // hover photo follows the chosen colour
    var alt = card.querySelector('.pc__alt');
    if (alt && dot.dataset.altSrc && alt.tagName === 'IMG') {
      alt.src = dot.dataset.altSrc;
      if (dot.dataset.altSrcset) alt.srcset = dot.dataset.altSrcset;
    }
  }
  // pick the variant for the chosen colour + option (e.g. Frosted White + Dry-Guard + Night Light) and refresh the card
  function choose(card, btn) {
    var list = variants(card);
    var idx = +btn.getAttribute('data-opt');
    var val = btn.getAttribute('data-value');
    var cur = sel(card).slice();
    cur[idx] = val;
    var same = function (v) { return v.o.every(function (o, i) { return o === cur[i]; }); };
    var v = list.filter(same)[0];
    if (!v) {
      // that combination doesn't exist: keep the clicked choice and take the nearest variant that has it
      var withIt = list.filter(function (x) { return x.o[idx] === val; });
      v = withIt.filter(function (x) { return x.a; })[0] || withIt[0];
      if (!v) return;
      cur = v.o.slice();
    }
    card.__pcs = cur;
    card.querySelectorAll('.pc__dot, .pc__pill').forEach(function (b) {
      var on = cur[+b.getAttribute('data-opt')] === b.getAttribute('data-value');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      // fade options that are sold out alongside the current choice
      if (b.classList.contains('pc__pill')) {
        var test = cur.slice(); test[+b.getAttribute('data-opt')] = b.getAttribute('data-value');
        var tv = list.filter(function (x) { return x.o.every(function (o, i) { return o === test[i]; }); })[0];
        b.classList.toggle('is-out', !tv || !tv.a);
      }
    });
    var id = card.querySelector('[data-pc-id]');
    if (id) id.value = v.id;
    var fmt = card.getAttribute('data-money');
    var keep = parseInt(card.getAttribute('data-keep'), 10) || 100;
    var price = Math.floor(v.p * keep / 100);
    var was = v.c > v.p ? v.c : (keep < 100 ? v.p : 0);
    var pEl = card.querySelector('[data-pc-price]');
    var wEl = card.querySelector('[data-pc-was]');
    var sEl = card.querySelector('[data-pc-save]');
    var oEl = card.querySelector('[data-pc-off]');
    var onSale = was > price;
    if (pEl) { pEl.textContent = money(price, fmt); pEl.classList.toggle('is-sale', onSale); }
    if (wEl) { wEl.textContent = onSale ? money(was, fmt) : ''; wEl.hidden = !onSale; }
    if (sEl) { sEl.textContent = onSale ? 'You save ' + moneyR(was - price, fmt) : ''; sEl.hidden = !onSale; }
    if (oEl) { var off = onSale ? Math.round((was - price) * 100 / was) : 0; oEl.textContent = 'Save ' + off + '%'; oEl.hidden = !off; }
    var add = card.querySelector('.pc__add');
    if (add && !add.classList.contains('is-done')) {
      add.disabled = !v.a;
      var label = add.querySelector('span');
      if (label) label.textContent = v.a ? 'Add to cart' : 'Sold out';
    }
    // product links open on the chosen option
    card.querySelectorAll('a.pc__ph, a.pc__nm').forEach(function (a) {
      var base = a.getAttribute('href').split('?')[0];
      a.setAttribute('href', base + '?variant=' + v.id);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc__dot, .pc__pill');
    if (!btn) return;
    var card = btn.closest('[data-pc]');
    if (!card) return;
    if (btn.classList.contains('pc__dot')) swapImages(card, btn);
    if (variants(card) && btn.hasAttribute('data-opt')) { choose(card, btn); return; }
    // simple cards (no option data): colour dot picks its own variant
    card.querySelectorAll('.pc__dot').forEach(function (d) { d.classList.remove('is-on'); });
    btn.classList.add('is-on');
    var id = card.querySelector('[data-pc-id]');
    if (id && btn.dataset.variant) id.value = btn.dataset.variant;
  });
  var updateCount = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      var n = bubble.querySelector('.pals-header__count');
      if (!n) { n = document.createElement('span'); n.className = 'pals-header__count'; bubble.appendChild(n); }
      n.textContent = c.item_count;
    }).catch(function () {});
  };
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pc-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.pc__add');
    var label = btn ? btn.querySelector('span') : null;
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (btn) { btn.classList.add('is-done'); if (label) label.textContent = 'Added'; }
        updateCount();
        setTimeout(function () { if (btn) { btn.classList.remove('is-done'); btn.disabled = false; if (label) label.textContent = 'Add to cart'; } }, 1500);
      })
      .catch(function () { form.removeAttribute('data-pc-form'); form.submit(); });
  });
})();
